import { Project } from "projen/lib";
import { PnpmWorkspace } from "../../pnpm/pnpm-workspace";
import { AgentRuleBundle } from "../agent-config-options";
import { AGENT_RULE_SCOPE } from "../types";
import { hasComponent } from "./utils";

/**
 * PNPM bundle — auto-detected when the PnpmWorkspace component is present.
 */
export const pnpmBundle: AgentRuleBundle = {
  name: "pnpm",
  description: "PNPM workspace rules and dependency management conventions",
  appliesWhen: (project: Project) => hasComponent(project, PnpmWorkspace),
  rules: [
    {
      name: "pnpm-workspace",
      description: "PNPM workspace and dependency management conventions",
      scope: AGENT_RULE_SCOPE.FILE_PATTERN,
      filePatterns: ["package.json", "pnpm-workspace.yaml", "pnpm-lock.yaml"],
      content: [
        "# PNPM Workspace Conventions",
        "",
        "## Package Management",
        "",
        "- Use **PNPM** for package management",
        "- Workspace configuration in `pnpm-workspace.yaml`",
        "- Dependencies managed through Projen, not directly in `package.json`",
        "- **Always use workspace dependencies** (`workspace:*` or `workspace:^`) for packages within this monorepo",
        "- Never use published NPM versions of internal packages; always reference the local workspace version",
        "",
        "## Dependency Management",
        "",
        "**DO:**",
        "- Configure dependencies in Projen configuration files (`.projenrc.ts` or `projenrc/*.ts`)",
        "- Add dependencies to `deps`, `devDeps`, or `peerDeps` arrays in project configuration",
        '- Use catalog dependencies when available (e.g., `"aws-cdk-lib@catalog:"`)',
        "- Ask the user to run the three-step regen sequence after updating dependency configuration: `pnpm i`, then `pnpm exec projen`, then `pnpm i` again. The leading `pnpm i` syncs `node_modules` with the lockfile so synth runs against the right configulator/projen/plugin versions; the trailing `pnpm i` picks up any dependency changes projen wrote during synth.",
        "",
        "**DO NOT:**",
        "- Run `npm install some-package`",
        "- Run `pnpm add some-package`",
        "- Run `yarn add some-package`",
        "- Manually edit `package.json` dependencies",
        "",
        "Manual package installation creates conflicts with Projen-managed files.",
      ].join("\n"),
      tags: ["workflow"],
    },
  ],
};
